import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { useDropzone } from 'react-dropzone';

const Container = styled.div`
  padding: 0;
  width: 245px;
  height: 114px;
`;

const Prompt = styled.a`
  border-radius: 3px;
  box-shadow: 0px 2px 4px rgba(50, 50, 71, 0.06), 0px 1px 4px rgba(50, 50, 71, 0.06);
  border: 1px solid transparent;
  background-color: #f8f9fc;
  width: 100%;
  height: 114px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    text-decoration: none;
    border-color: #c19d3f;
  }

  & > .fa-picture-o {
    font-size: 48px;
    margin-top: 20px;
    color: #bbcbd8;
    :hover {
      color: #bbcbd8;
    }
  }
`;

const Text = css`
  font-weight: 800;
  line-height: 120%;
  text-align: center;
  text-transform: uppercase;
  font-style: normal;
`;

const Strong = styled.strong`
  ${Text}
  font-size: 10px;
  margin-top: 10px;
  color: #19202d;

  &:hover {
    color: #19202d;
  }
`;

const Em = styled.em`
  ${Text}
  font-size: 12px;
  margin-top: 6px;

  &:hover {
    text-decoration: underline;
  }
`;

const MIN_HEIGHT = 306;

const buildOnDrop = (onError, onSuccess) => ([file]) => {
  const image = new Image();
  const blob = URL.createObjectURL(file);

  image.addEventListener('load', function onload() {
    URL.revokeObjectURL(blob);
    if (this.naturalHeight < MIN_HEIGHT) {
      onError(`The image is too small. Please upload an image of minimum ${MIN_HEIGHT}px height.`);
    } else {
      onError(null);
      onSuccess({ ...file, content: URL.createObjectURL(file) });
    }
  });
  image.src = blob;
};

export default function Dropzone({ onSuccess, onError }) {
  const {
    getRootProps, getInputProps, isDragActive, open,
  } = useDropzone({
    accept: 'image/png',
    multiple: false,
    noClick: true,
    onDrop: buildOnDrop(onError, onSuccess),
  });

  return (
    <Container {...getRootProps({ className: `dropzone${isDragActive ? ' active' : ''}` })}>
      <input {...getInputProps()} />
      <Prompt href="#" onClick={() => open()}>
        <span className="fa fa-picture-o" />
        <Strong>logo required</Strong>
        <Em>upload brand logo</Em>
      </Prompt>
    </Container>
  );
}

Dropzone.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
